import { useNavigation } from "@react-navigation/native";
import { View } from "react-native";
import { IconButton, TouchableRipple, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Flag from "../../../components/Flag";
import { LoginScreenProps, loginRoutes } from "../../../navigation/types";
import { Country } from "../../../types";

type Props = {
  selectedCountry: Country;
};

type NavProps = LoginScreenProps<typeof loginRoutes.country>;
export default function CountryPicker({ selectedCountry }: Props) {
  const { navigate } = useNavigation<NavProps["navigation"]>();

  const tailwind = useTailwind();
  const { colors } = useTheme();

  const backgroundColor = colors.surfaceVariant;

  const navigateToCountrySelect = () => navigate(loginRoutes.country);

  return (
    <TouchableRipple
      onPress={navigateToCountrySelect}
      style={[tailwind("rounded-lg"), { backgroundColor }]}
    >
      <View style={[tailwind("flex-row items-center p-2")]}>
        <Flag source={selectedCountry.logo} scale={1 / 3} />

        <IconButton icon="menu-down" style={tailwind("-m-1 -mr-4")} />
      </View>
    </TouchableRipple>
  );
}
